import { formato_get_url, formato_get_by_nombre_url } from "./urlBase"
import { apiCall } from "./apiCall";

const listar_formatos = async () => {

    try {

        // const token = localStorage.getItem('token')
        // const request = client(token)
        // const resp = await request.call( 'GET', formato_get_url, null )

        const resp = await apiCall( 'GET', formato_get_url, null )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('formatoHelper', '15')
            throw response
        }

    } catch ( e ) {
        console.log('formatoHelper', '20')
        throw e
    }
}

const listar_formatos_by_tipo = async (tipo, miembro) => {

    try {

        // const token = localStorage.getItem('token')
        // const request = client(token)
        // const resp = await request.call( 'GET', formato_get_by_nombre_url, null )
        if (miembro == '')
        miembro = '0';
console.log('miembro:::::::::::::::', miembro)
        const resp = await apiCall( 'GET', `${formato_get_by_nombre_url}/${tipo}/${miembro}`, null )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('formatoHelper', '15')
            throw response
        }

    } catch ( e ) {
        console.log('formatoHelper', '20')
        throw e
    }
}

export {
    listar_formatos,
    listar_formatos_by_tipo
}